module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-research-development-hero.b867996.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-research-development-hero.jpg
// module id = Kpmx
// module chunks = 0